import React from 'react';
import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons/faTrashAlt';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function TrashAltRegularIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faTrashAlt} {...props} />;
}
